let config = {
  emailjs: {
    serviceID: "service_zgn3pzg",
    templateID: "template_0p0xp5t",
    userID: "user_lvJPo2T7f3piQuVteW4Em"
  }
};



export default config;
